module.exports = __webpack_public_path__ + "static/media/V6-Amarok.db9ef375.webp";